import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

export const SidePanelWrapper = styled.div`
  position: fixed;
  right: 0;
  background-color: #fff;
  bottom: 0;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: transform 0.3s ease-in-out;
  pointer-events: ${p => (p.isOpen ? 'auto' : 'none')};
  padding: 24px;

  left: 0;
  width: 100%;
  height: 90%;
  transform: ${p => (p.isOpen ? 'translateY(0)' : 'translateY(100%)')};
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;

  @media only screen and (min-width: 768px) {
    left: unset;
    height: 100%;
    transform: translateY(0);
    border-top-right-radius: 0;

    top: 0;
    width: 600px;
    max-width: 80%;
    transform: ${p => (p.isOpen ? 'translateX(0)' : 'translateX(100%)')};
    border-bottom-left-radius: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 400;
  margin: 0;
`;

export const CloseButton = styled.button`
  position: relative;
  width: 20px;
  height: 20px;
  border: none;
  background: none;
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
  &:hover {
    opacity: 0.5;
  }
  &:active {
    opacity: 0.8;
  }
  &:after,
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 24px;
    height: 2px;
    background-color: ${commonPalette.iconDefault};
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export const Content = styled.div`
  width: 100%;
  height: calc(100% - 48px);
`;

export const Backdrop = styled.button`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: ${p => (p.showBackdrop ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: ${p => (p.showBackdrop ? 'auto' : 'none')};
  border: none;
  outline: none;
  tab-index: ${p => (p.showBackdrop ? 0 : -1)};
  &:active {
    outline: none;
  }
`;
